



<!DOCTYPE html>

<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css" rel="stylesheet">
  <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/js/bootstrap.bundle.min.js"></script>
  <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.0.8/css/all.css">
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
  <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css">
</head>







<div class="card" *ngIf="ShowCard===2">
  <div class="card-body">
<br>
    <div class="row">
      <p style="color: #6ab187;"><strong>EMPLOYEE SCREENING</strong></p>
      <div class="col-3"><img style="width: 37px;height: auto;" src="assets/users.png"><a style="text-decoration: none;color:black" routerLink="/whitecollar"> <strong class="white">&nbsp; White-collar verification</strong></a></div>
      <div class="col-3"><img style="width: 37px;height: auto;" src="assets/mechanic.png"><a style="text-decoration: none;color: black;"  routerLink="/bluecollar"><strong class="white"> Blue-collar verification</strong></a></div>
      <br><br>
      <div class="col-3"><img style="width: 37px;height: auto;" src="assets/online-business.png"><a style="text-decoration: none;color: black;" routerLink="/gigworker"> &nbsp;<strong class="white"> Gig Worker verification</strong></a></div>
    </div>
    <br>
    
    <div class="row">
      
      <p style="color: #6ab187;"><strong>RISK & COMPLIANCE</strong></p>
      <div class="col-3"><img style="width: 30px;height: auto;" src="assets/risktopicon.png"><a style="text-decoration: none;color: black;" routerLink="/riskmanage"><strong class="white"> Risk Management</strong></a></div>
      <div class="col-3"><img style="width: 35px;height: auto;" src="assets/onboarding.png"><a style="text-decoration: none;color: black;" routerLink="/vendor"><strong class="white" > Vendor Onboarding</strong></a></div>
      <div class="col-3"><img style="width: 40px;height: auto;" src="assets/distributortopicon.png"><a style="text-decoration: none;color: black;" routerLink="/distribute"><strong class="white"> Distributor onboarding</strong></a></div>
      <div class="col-3"><img style="width: 40px;height: auto;" src="assets/duediligence.jpg"><a style="text-decoration: none;color: black;" routerLink="/duediligence"><strong class="white"> Due Diligence</strong> </a></div>
    </div>
    <br>
  
    <!--  -->
    <div class="row">
      
      <p style="color: #6ab187;"><strong> FINANCIAL INTELLIGENCE</strong></p>
      <div class="col-3"><img style="width: 40px;height: auto;" src="assets/kycsolution.png"><a style="text-decoration: none;color: black;" routerLink="/kycsolution"><strong class="white"> KYC solutions</strong> </a></div>
    </div>
    <br>
  
  </div>
</div>


<div class="card" *ngIf="ShowCard===1">
  <div class="card-body">
<br>
<p style="color: #6ab187;font-weight: 600;"><strong>PRODUCT</strong></p>

    <div class="row">
      <div class="col"><a style="text-decoration: none;color: black;cursor: pointer;" (click)="ShowCard=3"><strong class="white"><img style="width: 4%;height: 100%;" src="assets/docverify.png"> Document Verification</strong> </a></div>
      <div class="col"><a style="text-decoration: none;color: black;cursor: pointer;" routerLink="/service"><strong class="white"><img style="width: 5%;height: 110%;" src="assets/docsignin.png"> Document SignIn</strong> </a></div>
    </div>
    <br>

    <div class="row">
       </div>
    <br>
    
  </div>
</div>


<!--  -->

<div class="card" *ngIf="ShowCard===3">
  <div class="card-body">
    <br>
<div class="row">
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/aadhartopicon.png"><a style="text-decoration: none;color: black;" routerLink="/aadhaar"> <strong class="white"> Aadhaar verification</strong></a></div>
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/pantopicon.png"><a style="text-decoration: none;color: black;"  routerLink="/pan"><strong class="white"> Pan verification</strong></a></div>
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/gsttopicon.jpg"><a style="text-decoration: none;color: black;" routerLink="/gst"><strong class="white"> Gst verification</strong></a></div>
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/drivinglicensetop.jpg"><a style="text-decoration: none;color: black;" routerLink="/driving"><strong class="white"> Driving verification</strong></a></div>
</div><br><br>

<div class="row">
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/passporttopicon.png"><a style="text-decoration: none;color: black;" routerLink="/passport"><strong class="white"> Passport verification</strong> </a></div>
  <div class="col"><img style="width: 58px;height: 44px;" src="assets/rcverify.png"><a style="text-decoration: none;color: black;" routerLink="/rcverify"><strong class="white"> RC verification</strong></a></div>
  <div class="col"><img style="width: 45px;height: 44px;" src="assets/msmeverify.png"><a style="text-decoration: none;color: black;" routerLink="/msmeverify"><strong class="white"> MSME verification</strong> </a></div>
  <div class="col"><img style="width: 45px;height: 44px;" src="assets/verification.png"><a style="text-decoration: none;color: black;" routerLink="/dinverify"><strong class="white"> DIN verification</strong></a></div>
</div>

<br><br>
<div class="row">
  <div class="col-3"><img style="width: 35px;height: 44px;border-radius: 20px;" src="assets/cinicon.png"><a style="text-decoration: none;color: black;" routerLink="/cinverify"><strong  class="white"> CIN verification</strong></a></div>
</div>
</div>
</div>


<br><br>


<!--  -->
<div class="row"  data-aos="zoom-in" data-aos-delay="300" >
  <div class="col-md-6 text-center">
    <img style="width:70%;height: 90%;margin-top:10%;border-radius:40px;box-shadow: 50px 20px #76b891;" src="assets/distributoronboard.jpg">
</div>
    <div style="padding-top: 10%;" class="col-md-6">
        <h1>
            <span class="topic">Distributor Onboarding and Risk Management Solution</span>
          </h1>
        <h5 style="padding-left: 10%;">&nbsp;&nbsp;&nbsp;Digitize your distributor onboarding while building a network of trusted distributor partnerships</h5>
    </div>

   
</div>
<br><br>

<div class="row mt-5" data-aos="zoom-in" data-aos-delay="300"  >
    <div class="col">
        <h1 style="color: #6ab187;text-align: center;">Transforming Distributor Onboarding and Screening</h1>
        <br>
        <p style="text-align: center;">Automating the entire distributor onboarding and verification process</p>


           <br><br>
<div  class="row p-2">

    <div style="background-color: #eff8ff;" data-aos="fade-up" data-aos-delay="300"  class="col-md-4">
        <br>
        <img style="width: 70px;height: 65px;background-color: #eff8ff;" src="assets/searchicon.png">
       <br><br><br>
        <h5>No More Scattered Data</h5>
        <p style="align-items: center;">Do away with the manual collection of distributor verification documents to get all the information for multiple distributors on a single platform.</p>
    </div>
  
    <div style="background-color: #c9d9e6;" data-aos="fade-up" data-aos-delay="300"  class="col-md-4">
          <br>
          <img style="width: 70px;height: 60px;" src="assets/compliancemanage.png">
         <br><br><br>
          <h5>Compliance Management</h5>
          <p style="align-items: center;">Streamline distributors’ adheres to regulatory and compliance requirements with an enterprise-ready distributor onboarding and verification solution.</p>
      </div>
     
       
    <div style="background-color: #eff8ff;" data-aos="fade-up" data-aos-delay="300"  class="col-md-4">
        <br>
        <img style="width: 80px;height: 70px;" src="assets/absentrisk.png">
       <br><br><br>
        <h5>Absence of Risk Framework</h5>
        <p style="align-items: center;">Eliminate compliance failures and huge financial, and reputational losses by establishing proper due diligence and risk mitigation process for distributor partners.</p>
    </div>


  </div>
    </div>
</div> 


<!--  -->
<br>
<div class="row" data-aos="zoom-in" data-aos-delay="300"   >
    <div class="col">
        <h5 style="text-align: center;">How to do Distributor Due Diligence?​</h5>
        <h2 style="color: #6ab187;text-align: center;">Distributor Onboarding and Due Diligence Process​</h2>
        <br><br><br><br>
        <img style="width: 5%;height: 27%;margin-left: 15%;" src="assets/initial.png">
        <img style="width: 4%;height: 18%;margin-left: 5%;" src="assets/arrow.jpg">

        <img style="width: 5%;height: 27%;margin-left: 5%;" src="assets/datacollect.png">
        <img style="width: 4%;height: 18%;margin-left: 5%;" src="assets/arrow.jpg">

        <img style="width: 5%;height: 27%;margin-left: 5%;" src="assets/due.jpg">
        <img style="width: 4%;height: 18%;margin-left: 5%;" src="assets/arrow.jpg">

        <img style="width: 5%;height: 27%;margin-left: 5%;" src="assets/approval.png">
        <img style="width: 4%;height: 18%;margin-left: 5%;" src="assets/arrow.jpg">

    </div>

</div>



<div class="row">
    <div class="col">
        <br><br><br><br><br>
        <img style="width: 5%;height: 39%;margin-left: 28%;" src="assets/contract.png">
        <img style="width: 4%;height: 18%;margin-left: 5%;" src="assets/arrow.jpg">
        
        <img style="width: 5%;height: 33%;margin-left: 30px;" src="assets/erpintegrate.png">
        <img style="width: 4%;height: 18%;margin-left: 5%;" src="assets/arrow.jpg">

        
        <img style="width: 5%;height: 33%;margin-left: 30px;" src="assets/monitoring.png">
    </div>
</div>




<!--  -->
<br><br>
<br><br>
<div class="row">
    <div class="col">
        <h3 style="color: #6ab187;text-align: center;">Facheck  Distributor Due Diligence Solution </h3>
        <h2 style="text-align: center;color: #6ab187;">Elevate Your Distributot Onboarding Process </h2>
     <p style="text-align: center;">Distributor Risk Mitigation at every step of the onboarding journey </p>
    </div>
</div>


<br><br><br><br>
<!--  -->
<div class="row p-2" data-aos="fade-up" data-aos-delay="300"  >
  <div class="col-md-6">
      <br>
      <img style="width: 39px;height: 39px;" src="assets/initiation.png">
      <span style="color: #6ab187;">Initiation</span><br>
      <h3 style="text-align: start;color: #6ab187;">Initiate Distributor Registration across Multiple Channels</h3>
      <p >Initiate the registration process for your distributors by sending the invitation link through multiple channels like email, SMS, or WhatsApp. You can choose to individually initiate the distributor onboarding process or bulk upload the details.</p>
  </div>

  <div class="col-md-6 text-center  ">
      <img style="width: 80%;height: 80%;margin-top: 20px;" src="assets/invite.png">
  </div>
  </div>



 <!--  -->
 
 <div class="row p-2 mt-4"  data-aos="fade-up" data-aos-delay="300" >
  
     <div class="col-md-6 text-center">
         <img style="width: 80%;height: 100%;margin-left: 20px;" src="assets/datacollection.jpg">
     </div>
 
     <div class="col">
         <img style="width: 42px;height: 45px;" src="assets/automation.png">
         <span style="color: #6ab187;height: 20%;">Automation</span>
         <h3 style="text-align: start;color: #6ab187;">Automating Distributor Data Collection</h3>
         <p >Let the distributor log in to the OnboardX portal and upload their documents eliminating paper-based, manual document collection. Set up configurable workflows to automate the collection of distributor documents such as PoI, PoA, GSTIN number, PAN, TAN, DIN, CIN and others to avoid manual errors while reducing the onboarding TAT.</p>
     </div>
 </div>



 
 <!--  -->
 <div class="row p-2"  data-aos="fade-up" data-aos-delay="300" >
   <div class="col-md-6">
       <br>
       <img style="width: 39px;height: 39px" src="assets/riskmitigatee.png">
       <span style="color: #6ab187;">Risk Management</span><br>
       <h3 style="text-align: start;color: #6ab187;">Distributor Due Diligence for Risk Mitigation</h3>
       <p >Validate the authenticity of the distributor, and evaluate their business health, reputational history, financial checks and other parameters to conduct effective due diligence using an expansive proprietary database combined with on-field capabilities. Doing this prevents fraud, reputational damage and other negative financial implication.</p>
   </div>
 
   <div class="col-md-6 text-center">
       <img style="width: 80%;height: 80%;margin-top: 20px;" src="assets/riskmanagement.jpg">
   </div>
   </div>


   
   <div class="row p-2" data-aos="fade-up" data-aos-delay="300" >
    
       <div class="col-md-6 text-center">
           <img style="width: 70%;height: 90%;margin-left: 20px;margin-top: 30px;" src="assets/approval.jpg">
       </div>
   
       <div class="col-md-6 mt-3">
           <img style="width: 42px;height: 45px" src="assets/approve.png">
           <span style="color: #6ab187;height: 20%;margin-top: 30px;">Approval Management</span>
           <h3 style="text-align: start;color: #6ab187;">Seamless Workflows for Approval Management
          </h3>
           <p >Overcome the delays with approvals by setting up automated workflows to remind all the stakeholders like the sales team, legal or business teams to vet the distributor and provide necessary approvals. Automating the approval process saves time and fastracks the finalization of the best distributor for your business.</p>
       </div>
   </div>



   
   <!--  -->
   <div class="row p-2" data-aos="fade-up" data-aos-delay="300" >
     <div class="col-md-6">
         <br>
         <img style="width: 39px;height: 42px;" src="assets/contractsign.jpg">
         <span style="color: #6ab187;">Digital Contracting</span><br>
         <h3 style="text-align: start;color: #6ab187;">Digitally Sign Distributor Agreements</h3>
         <p style="margin-left: 24px;">Do not let signing distributor agreements and contracts become a bottleneck. Make use of our digital signing tool to allow your distributors to upload their e-signatures or sign the contracts, documents and stamp papers using Aadhaar e-signature to close the deal faster. Collaborate with multiple parties to co-sign the contracts with complete transparency.</p>
     </div>
   
     <div class="col-md-6  text-center ">
         <img style="width: 80%;height: 90%;margin-top: 20px;" src="assets/digitalcontract.png">
     </div>
     </div>





     <div class="row p-2 " data-aos="fade-up" data-aos-delay="300"  >
      
         <div class="col-md-6  text-center ">
             <img style="width: 60%;height: 70%;margin-left: 20px;margin-top: 20px;" src="assets/erp.png">
         </div>
     
         <div class="col-md-6">
             <img style="width: 42px;height: 40px;" src="assets/seamless connect.png">
             <span style="color: #6ab187;height: 20%;margin-top: 30px;"> Seamless Connectivity</span>
             <h3 style="text-align: start;color: #6ab187;">Easy Integration with Enterprise-grade ERPs and Distributor Management Systems
            </h3>
             <p >Easily integrate with leading distributor management systems and ERPs such as SAP, Tally, Oracle, Microsoft, Salesforce, Zoho, and HANA to effectively use your existing systems while enjoying the benefits of new technology. Have complete visibility of ongoing engagement between different business functions with a common distributor to avoid chaos and improve operational efficiency.</p>
         </div>
     </div>
  

     <!--  -->
     <div class="row p-2" data-aos="fade-up" data-aos-delay="300"   >
       <div class="col-md-6">
           <br>
           <img style="width: 42px;height: 45px" src="assets/risklog.png">
           <span style="color: #6ab187;">Risk Assessment</span><br>
           <h3 style="text-align: start;color: #6ab187;">Continuous Risk Monitoring</h3>
           <p >Protect your business from any reputational, financial or identity risks by proactive continuous assessment of your distributors after they have been onboarded. Conduct frequent checks through public domain, subscribed databases, and sourced inquiries with industry experts such as EPFO compliance, GSTIN compliance, and Company court record check to be on top of probable risks or compliance gaps.</p>
       </div>
     
       <div class="col-md-6 text-center  ">
           <img style="width: 80%;height: 90%;margin-top: 20px;" src="assets/safeguard.png">
       </div>
       </div>



      
 <!-- advantages -->
  
 <div class="row p-2" data-aos="zoom-in" data-aos-delay="300" >
    <div class="col">
            <h2 style="text-align: center;font-size: 550;color: #6ab187;">Facheck Distributor Onboarding<br> and Management Solution</h2>
            <p style="text-align: center;">Built for Success at Every Step of the Distributor Onboarding Journey</p>
    </div>
    </div>
    <br>


    <div  class="row p-2">
  
        <div style="background-color: #eff8ff;" data-aos="fade-up" data-aos-delay="300"  class="col-md-3">
            <br>
            <img style="width: 60px;height: 65px;background-color: #eff8ff;" src="assets/signout.png">
           <br><br><br>
            <h5>Single Sign-on</h5>
            <p style="align-items: center;">For Secure User Authentication and Compliance</p>
        </div>
      
        <div style="background-color: #c9d9e6;" data-aos="fade-up" data-aos-delay="300"  class="col-md-3">
              <br>
              <img style="width: 70px;height: 80px;" src="assets/multiple.png">
             <br><br>
              <h5>Multi-Channel Engagement </h5>
              <p style="align-items: center;">To Streamline Communication</p>
          </div>
         
          <div  style="background-color: #eff8ff;" data-aos="fade-up" data-aos-delay="300"  class="col-md-3">
         
            <br>
            <img style="width: 60px;height: 60px;" src="assets/report&dashboard.png">
           <br><br><br>
            <h5>Interactive Dashboards & Custom Reports </h5>
            <p style="align-items: center;">Real-time tracking of case status<p>
        </div>
    
    
        <div style="background-color: #eff8ff;" data-aos="fade-up" data-aos-delay="300"   class="col-md-3">
            <br>
            <img style="width: 60px;height: 65px;background-color: #eff8ff;" src="assets/multilingual.png">
           <br><br><br>
            <h5>Multilingual Forms</h5>
            <p style="align-items: center;">For expanding the reach and improving conversions</p>
        </div>

        <div style="background-color: #eff8ff;" data-aos="fade-up" data-aos-delay="300"   class="col-md-3">
          <br>
          <img style="width: 60px;height: 65px;background-color: #eff8ff;" src="assets/vendorrepo.png">
         <br><br><br>
          <h5>Vendor Respitory</h5>
          <p style="align-items: center;">To create a list of all the vendors for future use</p>
      </div>
    
      <div style="background-color: #c9d9e6;" data-aos="fade-up" data-aos-delay="300"  class="col-md-3">
            <br>
            <img style="width: 70px;height: 80px;" src="assets/propriotary.png">
           <br><br>
            <h5>1Bn+ Proprietary Database</h5>
            <p style="align-items: center;">For quicker verification and turnaround time (TAT)</p>
        </div>
       
        <div  style="background-color: #eff8ff;" data-aos="fade-up" data-aos-delay="300"  class="col-md-3">
       
          <br>
          <img style="width: 60px;height: 60px;" src="assets/crmerp.png">
         <br><br><br>
          <h5>Integration with ERP/CRMs</h5>
          <p style="align-items: center;">Two-way communication across multiple channels<p>
      </div>
  
  
      <div style="background-color: #eff8ff;" data-aos="fade-up" data-aos-delay="300"   class="col-md-3">
          <br>
          <img style="width: 60px;height: 65px;background-color: #eff8ff;" src="assets/customizedalert.jpg">
         <br><br><br>
          <h5>Customized Alerts and Notifications</h5>
          <p style="align-items: center;">To keep track of case status and notify stakeholders</p>
      </div>
      </div>
      
      

    
    
      
      
     
      



<!--  -->

<div class="row" data-aos="zoom-in" data-aos-delay="300" >
    <div class="col">
      <br><br><br>
        <h3 style="text-align: center;color: #6ab187;">20+  Distributor Screening and Onboarding Checks</h3><br>
        <p style="text-align: center;">Built for Success at Every Step of the Onboarding Journey</p>
    </div>

</div>
<br><br>


<!--  -->
<div  class="row p-2 text-center">
  <div class="col-md-3 mt-2  "  data-aos="fade-up" data-aos-delay="300"    >
      <div  class="card"  style="height: 180px;" >
          <div class="card-body">
              <img style="width: 34%;height:30%" src="assets/udyogaadhaar.jpg">
              <br><br>
            <h5 class="card-title">Udyog Aadhaar</h5>
          </div>            
        </div>
  </div>

  <div class="col-md-3 mt-2  "  data-aos="fade-up" data-aos-delay="300"    >
    <div class="card"  style="height: 180px;" >
        <div class="card-body">
            <img style="width: 34%;height:30%" src="assets/bankaccount.png">
            <br><br>
          <h5 class="card-title">Bank Account</h5>
        </div>            
      </div>
</div>

<div class="col-md-3 mt-2  "  data-aos="fade-up" data-aos-delay="300"    >
  <div class="card"  style="height: 180px;" >
      <div  class="card-body">

          <img style="width: 30%;height:30%" src="assets/directorcheck.jpg">
          <br><br>
        <h5 class="card-title">Defaulting Directors Check</h5>
      </div>            
    </div>
</div>

<div class="col-md-3 mt-2  "  data-aos="fade-up" data-aos-delay="300"    >
<div class="card"  style="height: 180px;" >
    <div class="card-body">
        <img style="width: 34%;height:30%"  src="assets/tincheck.png">
        <br><br>
      <h5 class="card-title">TIN Check</h5>

    </div>            
  </div>
</div>

<div class="col-md-3 mt-2  "  data-aos="fade-up" data-aos-delay="300"    >
  <div  class="card"  style="height: 180px;" >
      <div class="card-body">
          <img style="width: 34%;height:30%" src="assets/businesswork.png">
          <br><br>
        <h5 class="card-title">Business address</h5>
      </div>            
    </div>
</div>

<div class="col-md-3 mt-2  "  data-aos="fade-up" data-aos-delay="300"    >
<div class="card"  style="height: 180px;" >
    <div class="card-body">
        <img style="width: 34%;height:30%" src="assets/GSTIN.jpg">
        <br><br>
      <h5 class="card-title">GSTIN verify</h5>
    </div>            
  </div>
</div>

<div class="col-md-3 mt-2  "  data-aos="fade-up" data-aos-delay="300"    >
<div class="card"  style="height: 180px;" >
  <div  class="card-body">

      <img style="width: 30%;height:30%" src="assets/panchecks.png">
      <br><br>
    <h5 class="card-title">PAN Card</h5>
  </div>            
</div>
</div>

<div class="col-md-3 mt-2  "  data-aos="fade-up" data-aos-delay="300"    >
<div class="card"  style="height: 180px;" >
<div class="card-body">
    <img style="width: 34%;height:30%"  src="assets/dinverify.jpg">
    <br><br>
  <h5 class="card-title">DIN verify</h5>
</div>            
</div>
</div>

</div>

<br>


<!--  -->









